import React, { useState, useEffect, useCallback } from 'react';
import './Carousel.css';

const slides = [
  {
    id: 1,
    image: '/siteimage/WhatsApp Image 2026-06-30 at 12.17.23.jpeg',
    title: 'Luxury Living Redefined',
    subtitle: 'Discover premium properties in the heart of the city',
  },
  {
    id: 2,
    image: '/siteimage/WhatsApp Image 2026-06-30 at 12.17.23 (2).jpeg',
    title: 'Your Dream Home Awaits',
    subtitle: 'Spacious apartments with world-class amenities',
  },
  {
    id: 3,
    image: '/siteimage/WhatsApp Image 2026-06-30 at 12.17.23 (3).jpeg',
    title: 'Modern Architecture',
    subtitle: 'Thoughtfully designed spaces for modern living',
  },
  {
    id: 4,
    image: '/siteimage/WhatsApp Image 2026-07-15 at 13.23.39.jpeg',
    title: 'Premium Residences',
    subtitle: 'Exclusive properties with stunning views',
  },
  {
    id: 5,
    image: '/siteimage/WhatsApp Image 2026-07-15 at 13.23.39 (1).jpeg',
    title: 'Find Your Perfect Space',
    subtitle: 'Browse our curated collection of finest homes',
  },
];

export default function Carousel() {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % slides.length);
  }, []);

  const prev = () => {
    setCurrent(prev => (prev - 1 + slides.length) % slides.length);
  };

  const goTo = (index) => {
    setCurrent(index);
  };

  // Auto-play every 3.5 seconds
  useEffect(() => {
    if (paused) return;
    const timer = setInterval(next, 3500);
    return () => clearInterval(timer);
  }, [paused, next]);

  return (
    <section className="carousel-section">
      <div className="carousel-header">
        <h2>Explore Our Properties</h2>
        <p>A glimpse into the finest real estate we offer</p>
      </div>

      <div
        className="carousel-wrapper"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        {/* Slides */}
        <div className="carousel-track">
          {slides.map((slide, i) => (
            <div
              key={slide.id}
              className={`carousel-slide ${i === current ? 'active' : i === (current - 1 + slides.length) % slides.length ? 'prev' : ''}`}
            >
              <img src={slide.image} alt={slide.title} />
              <div className="slide-overlay" />
              <div className="slide-content">
                <h3>{slide.title}</h3>
                <p>{slide.subtitle}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Prev / Next Arrows */}
        <button className="carousel-btn prev-btn" onClick={prev} aria-label="Previous">
          <i className="fa fa-chevron-left" />
        </button>
        <button className="carousel-btn next-btn" onClick={next} aria-label="Next">
          <i className="fa fa-chevron-right" />
        </button>

        {/* Dots */}
        <div className="carousel-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`cdot ${i === current ? 'active' : ''}`}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        {/* Progress bar */}
        <div className="carousel-progress">
          <div
            className={`progress-bar ${!paused ? 'running' : ''}`}
            key={current}
          />
        </div>
      </div>

      {/* Thumbnail strip */}
      <div className="carousel-thumbs">
        {slides.map((slide, i) => (
          <button
            key={slide.id}
            className={`thumb ${i === current ? 'active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Thumbnail ${i + 1}`}
          >
            <img src={slide.image} alt={slide.title} />
            <div className="thumb-overlay" />
          </button>
        ))}
      </div>
    </section>
  );
}
